import { types, getEnv, flow, SnapshotOut, Instance } from 'mobx-state-tree';
import { observable } from 'mobx';
import { IAppEnv } from '../appEnvironment';
import { TopOfferStore } from './topOfferStore';
import { TopBetsStore } from './topBets';
import { HotBetsStore } from './hotBets';
//import { ticketEventsOfTheDayStore } from './ticketEventsOfTheDay';
import { TopBetsCustomCategory } from './topBetsCustomCategory';
import { ProgressStateModelForStore, IGroupedApiCtx, OddModel, INewsList, IGame, IDetail, IOdds, IHomeTab, IWebHomeData, errorIsCancel, ProgressStateModel, TopOfferTypePB, getCompetitorNamesFromEventName, getRenameTipDataFromCompetitorNames, protoUtils } from 'eTip--common';
import { TopOfferType } from '../api/topOfferType';
import { ISportsBettingApi } from '../api/api';
import { RecommendedStore } from './recommended';
import { ticketEventsOfTheDayStore } from './ticketEventsOfTheDay';
import { translation } from 'easit--localization';
import { Top5PerDayStore } from './top5perDay';
import { Top10PerDayStore } from './top10perDay';

export const homeTabModel = types
    .model({
        Id: types.number,
        Title: types.string,
        TopOfferType: types.number, //TopOfferTypePB
        TypeAdditionalData: types.maybeNull(types.string),
        Route: types.string,
        RowCount: types.optional(types.number, -1)
    })
    .views(self => ({
        isActive(tabRoute: string) {
            return tabRoute == self.Route;
        }
    }));

export const HomeStoreKey = 'homeStore';
export const HomeStore = types
    .model(HomeStoreKey, {
        tabs: types.optional(types.array(homeTabModel), []),
        tabsState: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized),
        defaultTab: types.maybeNull(types.string),
        topBets: types.optional(TopBetsStore, {
            events: []
        }),
        topOffer: types.optional(TopOfferStore, {
            categories: []
        }),
        hotBets: types.optional(HotBetsStore,
            {
                events: []
            }
        ),
        top5PerDay: types.optional(Top5PerDayStore, {
            events: []
        }),
        top10PerDay: types.optional(Top10PerDayStore, {
            events: []
        }),
        ticketEventsOfTheDay: types.optional(ticketEventsOfTheDayStore, {}),
        technicalInfo: types.optional(types.string, ''),
        technicalInfoId: types.maybeNull(types.number),
        recommended: types.optional(types.array(RecommendedStore), []),
        topBetsCustomCategories: types.optional(types.map(TopBetsCustomCategory), {} /* never used for Tipos but must be non null */)
    })
    .views(self => ({
        isTabDefault(tab: string) {
            return tab == self.defaultTab;
        }
    }))
    .actions(self => {
        const env = getEnv<IAppEnv>(self);

        let topLiveRowCountToBeAssigned: Number = null;
        let beforeFirstSetTabs = true;
        let synchroCtxForHome: IGroupedApiCtx<ISportsBettingApi> | null = null;

        const setTabs = (tabs: IHomeTab[]) => {
            self.tabs = observable(tabs.map(v => homeTabModel.create(
                <SnapshotOut<typeof homeTabModel>>{
                    Id: v.Id, Title: v.Title, TopOfferType: v.TopOfferType.valueOf(),
                    TypeAdditionalData: v.TypeAdditionalData, Route: getTabRoute(v.TopOfferType, v.TypeAdditionalData)
                }
            )));
            self.defaultTab = (self.tabs.length > 0 && self.tabs[0].Route) || null;
            if (beforeFirstSetTabs) {
                beforeFirstSetTabs = false;
                if (topLiveRowCountToBeAssigned != null) {
                    setTopLiveRowCount({ rowCount: topLiveRowCountToBeAssigned.valueOf() });
                    topLiveRowCountToBeAssigned = null;
                }
            }

            //let foundCats = new Set<string>();
            tabs.forEach((t: IHomeTab) => {
                if (t.TopOfferType === TopOfferTypePB.CustomCategory) {
                    if (t.TypeAdditionalData == null || t.TypeAdditionalData.length == 0) {
                        throw new Error("Missing TypeAdditionalData");
                    }
                    if (!self.topBetsCustomCategories.has(t.TypeAdditionalData)) {
                        self.topBetsCustomCategories.set(t.TypeAdditionalData, TopBetsCustomCategory.create(
                            <SnapshotOut<typeof TopBetsCustomCategory>>{ typeAdditionalData: t.TypeAdditionalData }, env
                        ))
                    }
                    //foundCats.add(t.TypeAdditionalData);
                }
            });
            /* not used now
            let keysToRemove: string[] = [];
            let iterableKeys = self.topBetsCustomCategories.keys();
            let item = iterableKeys.next();
            while (!item.done) {
                let key = item.value;
                if (!foundCats.has(key)) {
                    keysToRemove.push(key);
                }
                item = iterableKeys.next();
            }
            keysToRemove.forEach(key => {
                self.topBetsCustomCategories.delete(key); //TODOH dispose it somehow?
            });*/
        };

        const createOddModel = (eventId: number, item: any, rename?: { [key: string]: string }) => {
            if (!item) return null;
            return OddModel.create(<SnapshotOut<typeof OddModel>>{
                name: rename && rename[item.TipName] ? rename[item.TipName] : item.TipName,
                rate: item.Rate,
                ident: `${eventId}-${item.GameId}-${item.DetailId}_${item.TipId}_${item.Rate.toFixed(2)}-0`,
                key: `${eventId}-${item.GameId}-${item.DetailId}_${item.TipId}`
            });
        };

        const setRecommended = (recommended: INewsList) => {
            if (recommended && recommended.News.length) {
                self.recommended = observable([]);
                recommended.News.forEach(r => {

                    let game: IGame = null;
                    let detail: IDetail = null;
                    let odds: IOdds[] = null;
                    if (!!r.Odds && r.Odds.Game) {
                        game = r.Odds.Game;
                        if (game.Details && game.Details.length > 0) {
                            detail = game.Details[0];
                            odds = detail.OddsList;
                        }
                    }
                    self.recommended.push(
                        RecommendedStore.create(<SnapshotOut<typeof RecommendedStore>>
                            {
                                iD: r.Id,
                                imgUrl: r.ImgUrl,
                                title: r.Title,
                                text: r.Text,
                                odds: game && detail && odds
                                    ? observable(
                                        r.Odds.Game[0].Detail.Odds.map((o: any) =>
                                            createOddModel(protoUtils.protoLongNumberToNumber(r.Odds.EventId), o, getRenameTipDataFromCompetitorNames(getCompetitorNamesFromEventName(r.Odds.EventName)))
                                        )
                                    )
                                    : null
                            })
                    );
                });
            }
        };

        const loadHomeInfoAsync: () => Promise<void> = flow(function* () {
            let ctx: IGroupedApiCtx<ISportsBettingApi> | null = null;

            if (synchroCtxForHome && synchroCtxForHome.isOpen()) {
                synchroCtxForHome.cancel();
                synchroCtxForHome = null;
            }
            try {
                ctx = env.api.open();
                synchroCtxForHome = ctx;
                const r: IWebHomeData = yield env.webHomeDataProxy.loadAsync(ctx);
                self.technicalInfo = r.TechnicalInformation ? r.TechnicalInformation.Text : '';
                self.technicalInfoId = r.TechnicalInformation ? r.TechnicalInformation.Id : null;

                setTabs(r.HomeTabs.HomeTabs);
                setRecommended(r.Recommended);
            } catch (error) {
                if (errorIsCancel(error)) {
                    throw error;
                }
                self.tabsState = ProgressStateModel.Failed;
                env.loggingService.error(error);
            } finally {
                if (synchroCtxForHome === ctx) {
                    synchroCtxForHome = null;
                }
            }
        });

        const setTopLiveRowCount = (param: { rowCount: number }) => {
            var tab = self.tabs.find(item => item.TopOfferType == TopOfferType.TopLive);
            if (tab) {
                tab.RowCount = param.rowCount;
            } else if (beforeFirstSetTabs) {
                topLiveRowCountToBeAssigned = param.rowCount;
            }
        };

        const getTabRoute = (topOfferType: TopOfferTypePB, typeAdditionalData?: string): string => {
            switch (topOfferType) {
                case TopOfferTypePB.TopLive: return translation().route_HomeLiveDesktop;
                case TopOfferTypePB.TopBets: return translation().route_HomeTopBetsDesktop;
                case TopOfferTypePB.TopPonuka: return translation().route_HomeTopOfferDesktop;
                case TopOfferTypePB.HotBets: return translation().route_HomeHotBetsDesktop;
                case TopOfferTypePB.TicketOfDay: return translation().route_HomeTicketOfDayDesktop;
                case TopOfferTypePB.CustomCategory: return (`cc_${typeAdditionalData}`);
                case TopOfferTypePB.Top5PerDay: return translation().route_Top5Bets;
                case TopOfferTypePB.Top10PerDay: return translation().route_Top10Bets;
                default: return "";
            }
        }

        return {
            setTopLiveRowCount,
            loadHomeInfoAsync
        };
    });
export type IHomeStore = Instance<typeof HomeStore>;
